module.exports = __webpack_public_path__ + "img/github.3f5de6f6.svg";